import { GridApi } from 'ag-grid-community/dist/lib/gridApi'
import { useEffect, useRef } from 'react'

export const useRefreshTable = ({
  params,
  gridApi,
}: {
  params: unknown
  gridApi: GridApi | null
}) => {
  const isFirstRenderWithApi = useRef(true)
  const lastParamsKeyRef = useRef<string | null>(null)

  useEffect(() => {
    const currentParamsKey = JSON.stringify(params ?? {})
    const paramsChanged = lastParamsKeyRef.current !== currentParamsKey

    if (!isFirstRenderWithApi.current && paramsChanged) {
      gridApi?.sizeColumnsToFit()
      // For infinite row model, refresh the cache instead of serverSide
      gridApi?.purgeInfiniteCache?.()
    }

    lastParamsKeyRef.current = currentParamsKey
    if (gridApi !== null) {
      isFirstRenderWithApi.current = false
    }
  }, [gridApi, params])
}
